<div class="profile-dialog-backdrop" *ngIf="visible || justSaved" (click)="close()">
  <section class="profile-dialog" role="dialog" aria-modal="true" aria-label="Chỉnh sửa hồ sơ" (click)="$event.stopPropagation()">
    <div class="profile-dialog-header">
      <h3>Chỉnh sửa hồ sơ</h3>
      <button type="button" class="profile-close-btn" (click)="close()" aria-label="Đóng">×</button>
    </div>

    <div class="profile-dialog-body">
      <label>Tên hiển thị</label>
      <input type="text" [(ngModel)]="draftUserName" [disabled]="!isEditing || submitting" placeholder="Nhập tên hiển thị" />

      <label>Số điện thoại</label>
      <input
        type="text"
        inputmode="numeric"
        autocomplete="tel"
        pattern="[0-9]*"
        [(ngModel)]="draftPhoneNumber"
        (input)="onPhoneNumberInput($event)"
        [disabled]="!isEditing || submitting"
        placeholder="Nhập số điện thoại"
        maxlength="10" />

      <label>Ngày sinh</label>
      <input type="date" [(ngModel)]="draftBirthDay" [max]="maxBirthDate" [disabled]="!isEditing || submitting" />

      <div class="profile-error" *ngIf="localError">{{ localError }}</div>
      <div class="profile-error" *ngIf="hasError && errorMessage">{{ errorMessage }}</div>
      <div class="profile-info" *ngIf="!hasError && errorMessage">{{ errorMessage }}</div>
      <div class="profile-success" *ngIf="justSaved">Hồ sơ vừa cập nhật</div>

      <div class="profile-actions">
        <button type="button" class="button close-button" (click)="close()" [disabled]="submitting">Đóng</button>
        <button
          type="button"
          class="button save-button"
          (click)="handleEditSave()"
          [disabled]="isEditing && (submitting || !isDirty)"
        >
          <span *ngIf="!submitting">{{ isEditing ? 'Lưu hồ sơ' : 'Chỉnh sửa' }}</span>
          <span *ngIf="submitting">Đang lưu...</span>
        </button>
      </div>
    </div>
  </section>
</div>
